import React from "react";
var __jsx = React.createElement;
import GoogleMapsHappyHealthyPetsV2 from './GoogleMapsHappyHealthyPetsV2';
function GoogleMapsHappyHealthyPetsV2Adapter(_ref) {
  var entry = _ref.entry;
  return __jsx(GoogleMapsHappyHealthyPetsV2, {
    happyHealthyPetsData: entry
  });
}
export default GoogleMapsHappyHealthyPetsV2Adapter;